import SubtitleTypography from "@/components/report/commons/SubtitleTypography";
import { UserType } from "@/components/report/types";
import { Divider, Stack } from "@mui/material";
import SleepFactorJudgementCriteriaDialogButton from "../HelpDialog/SleepFactorJudgementCriteriaDialogButton";
import { ThreeLevelScalesType } from "../commons";
import DeviceMeasurementData, { ChartData } from "./DeviceMeasurementData";
import Quality from "./Quality";
import Quantity from "./Quantity";
import Rhythm from "./Rhythm";
import { SleepJudgeTitle } from "./commons";

export interface SleepJudgeProps {
  sleep_length: (ThreeLevelScalesType | null)[];
  sleep_length_result: SleepJudgeTitle;
  sleep_length_summary: string;
  sleep_quality: (ThreeLevelScalesType | null)[];
  sleep_quality_result: SleepJudgeTitle;
  sleep_quality_summary: string;
  sleep_rhythm: (ThreeLevelScalesType | null)[];
  sleep_rhythm_result: SleepJudgeTitle;
  sleep_rhythm_summary: string;
  chart_data: ChartData[];
  uuid: string | undefined;
  userType: UserType;
}
export default function SleepJudge({
  uuid,
  userType,
  sleep_length,
  sleep_length_result,
  sleep_length_summary,
  sleep_quality,
  sleep_quality_result,
  sleep_quality_summary,
  sleep_rhythm,
  sleep_rhythm_result,
  sleep_rhythm_summary,
  chart_data,
}: SleepJudgeProps) {
  return (
    <Stack sx={{ mb: 12 }}>
      <Stack
        sx={{ mt: "48px", mx: 6, mb: 8 }}
        direction="row"
        justifyContent="space-between"
      >
        <SubtitleTypography>睡眠の判定</SubtitleTypography>
        <SleepFactorJudgementCriteriaDialogButton />
      </Stack>
      <Stack gap={12}>
        <Quantity
          uuid={uuid}
          userType={userType}
          title={sleep_length_result}
          summary={sleep_length_summary}
          result={sleep_length}
        />
        <Quality
          uuid={uuid}
          userType={userType}
          title={sleep_quality_result}
          summary={sleep_quality_summary}
          result={sleep_quality}
        />

        <Rhythm
          uuid={uuid}
          userType={userType}
          title={sleep_rhythm_result}
          summary={sleep_rhythm_summary}
          result={sleep_rhythm}
        />
      </Stack>
      <Divider
        sx={{
          mx: 6,
          mt: 12,
          mb: 6.5,
        }}
      />
      <DeviceMeasurementData
        uuid={uuid}
        userType={userType}
        chart_data={chart_data}
      />
    </Stack>
  );
}
